type InputFieldProps = {
  label: string;
  placeholder: string;
  type?: string;
  className?: string;
  classLabel?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const InputField = ({
  label,
  placeholder,
  type = "text",
  className = "",
  classLabel = "w-full",
  value,
  onChange,
}: InputFieldProps) => (
  <div className={`w-full space-y-1 ${className}`}>
    <label className={`text-[#1E293B] text-sm  ${classLabel}`}>{label}</label>
    <input
      type={type}
      placeholder={placeholder}
      value={value} // supports controlled input
      onChange={onChange} // supports controlled input
      className="px-4 py-2 text-sm w-full rounded-full outline-none bg-white border border-[#D8D8D8]"
    />
  </div>
);

export default InputField;
